import { PERISCOPE_PROFILES_COPY } from '@sonar-software/sonar-ts-constants';
import { PeriscopeSfProfile } from '@sonar-software/sonar-ts-types';
import React from 'react';
import { SonarRecord } from '@ui/records';

export type ProfileClickHandler = (item: PeriscopeSfProfile) => void;

export interface PeriscopeProfileProps {
	onClick?: ProfileClickHandler;
	item: PeriscopeSfProfile;
}

export const PeriscopeProfile: React.FC<PeriscopeProfileProps> = ({ item }) => {
	const accessInfo = item.hasEditAccess ? PERISCOPE_PROFILES_COPY.EDIT_ACCESS : PERISCOPE_PROFILES_COPY.READ_ACCESS;

	return (
		<SonarRecord
			isActive={ item.isActive }
			name={ item.displayName }
			secondaryInfo={ accessInfo }
			sonarObjectId={ item.sonarObjectId } />
	);
};
